<qr-overlay-topbar (close)="close.emit()">Descargar listado </qr-overlay-topbar>

<div class="download-modal">
  <div class="download-modal__title">
    <p>Seleccione una modalidad de descarga</p>
  </div>
  <div class="download-modal__body">
    <div
      class="download-modal__option download-modal__option--first"
      [ngClass]="{
        'download-modal__option--active': selectedOption === 'first'
      }"
      (click)="selectedOption = 'first'"
    >
      <p
        class="download-modal__label"
        [ngClass]="{
          'download-modal__label--selected': selectedOption === 'first'
        }"
      >
        Búsqueda actual
      </p>
      <mat-checkbox [checked]="selectedOption === 'first'" color="primary">
      </mat-checkbox>
    </div>

    <div
      class="download-modal__option download-modal__option--second"
      [ngClass]="{
        'download-modal__option--active': selectedOption === 'second'
      }"
      (click)="selectedOption = 'second'"
    >
      <p
        class="download-modal__label"
        [ngClass]="{
          'download-modal__label--selected': selectedOption === 'second'
        }"
      >
        Mensual
      </p>
      <div class="download-modal__dropdowns">
        <qr-dropdown
          class="download-modal__months"
          [isDisabled]="selectedOption !== 'second'"
          [config]="dropdownMonths"
          [selected]="selectedMonth"
          (change)="dropdownMonthChange($event)"
        ></qr-dropdown>
        <qr-dropdown
          class="download-modal__years"
          [isDisabled]="selectedOption !== 'second'"
          [config]="dropdownYears"
          [selected]="yearSelected"
          (change)="dropdownYearChange($event)"
        ></qr-dropdown>
      </div>
    </div>

    <div
      class="download-modal__option download-modal__option--third"
      [ngClass]="{
        'download-modal__option--active': selectedOption === 'third'
      }"
      (click)="selectedOption = 'third'"
    >
      <p
        class="download-modal__label"
        [ngClass]="{
          'download-modal__label--selected': selectedOption === 'third'
        }"
      >
        Anual
      </p>
      <qr-dropdown
        class="download-modal__anual"
        [isDisabled]="selectedOption !== 'third'"
        [config]="dropdownYears"
        [selected]="yearSelected"
        (change)="dropdownYearChange($event)"
      ></qr-dropdown>
    </div>
  </div>
</div>

<div class="actions">
  <qr-button [config]="buttonGoBack" (click)="closeDialog()"></qr-button>
  <qr-button
    [config]="buttonDownload"
    class="actions__btn-download"
    (click)="downloadProcess()"
  ></qr-button>
</div>
